<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark>mdi-arrow-left</v-icon>
          </v-btn>
          Edit Room
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model="form.name"
                outlined
                label="Name"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.seat_count"
                outlined
                label="Seats"
                prepend-inner-icon="mdi-seat"
                type="number"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <label for="profileFile" class="block font-medium mb-2"
                >Profile Image:</label
              ><br />
              <input
                type="file"
                id="profileFile"
                name="profileFile"
                ref="profileFile"
                @change="onFileChange($event, 'profile')"
              />
              <v-btn
                x-small
                color="red"
                class="my-1"
                dark
                @click="resetImage('profile')"
                >Remove</v-btn
              >

              <div v-if="profile_path" class="mt-5">
                <label>Image Preview</label><br />
                <img
                  :src="profile_path"
                  style="height: 30%; width: 30% !important"
                />
              </div>
            </v-col>

            <v-col sm="4">
              <label for="backgroundFile" class="block font-medium mb-2"
                >Background Image:</label
              ><br />
              <input
                type="file"
                id="backgroundFile"
                name="backgroundFile"
                ref="backgroundFile"
                @change="onFileChange($event, 'background')"
              />
              <v-btn
                x-small
                color="red"
                class="my-1"
                dark
                @click="resetImage('background')"
                >Remove</v-btn
              >

              <div v-if="background_path" class="mt-5">
                <label>Image Preview</label><br />
                <img
                  :src="background_path"
                  style="height: 30%; width: 30% !important"
                />
              </div>
            </v-col>

            <v-col sm="4" v-if="form.is_private">
              <v-text-field
                v-model="form.password"
                outlined
                label="Enter Room Password"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col>

            <v-col sm="4">
              <v-switch
                class="mt-0 ml-5"
                v-model="form.is_private"
                inset
                :label="`Is Private: ${form.is_private ? 'YES' : 'NO'}`"
              ></v-switch>
            </v-col>

            <v-col sm="4">
              <v-switch
                class="mt-0 ml-5"
                v-model="form.is_active"
                inset
                :label="`Is Active: ${form.is_active ? 'YES' : 'NO'}`"
              ></v-switch>
            </v-col>
          </v-row>

          <v-divider class="my-5"></v-divider>

          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Update Room
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";

export default {
  name: "RoomEditPage",
  data() {
    return {
      form: {
        name: "",
        seat_count: "",
        is_private: false,
        is_active: false,
        password: "",
        owner_id: null,
      },
      isLoading: false,
      old_json: {},
      background_path: null,
      profile_path: null,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      try {
        const encryptedId = this.$route.params.roomId;
        const response = await axios.get(`/rooms/${encryptedId}`);
        this.form = response.data.data;
        this.form.password = "";
        this.old_json = response.data.data;

        // Set preview image URLs
        if (this.form.profile_path) {
          this.profile_path = this.mediaUrl + this.form.profile_path;
        }
        if (this.form.background_path) {
          this.background_path = this.mediaUrl + this.form.background_path;
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        this.isLoading = false;
      }
    },

    async save() {
      try {
        this.isLoading = true;

        const formData = new FormData();
        this.form.is_private = this.form.is_private ? 1 : 0;
        // Append form fields
        for (const key in this.form) {
          formData.append(key, this.form[key]);
        }

        // Method spoofing for PATCH
        // formData.append("_method", "PATCH");

        // Append files
        const profileFile = this.$refs.profileFile?.files[0];
        const backgroundFile = this.$refs.backgroundFile?.files[0];
        if (profileFile) formData.append("profile_path", profileFile);
        if (backgroundFile) formData.append("background_path", backgroundFile);

        await axios.post(`/rooms/${this.$route.params.roomId}`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        this.$router.push("/rooms");
      } catch (e) {
        console.error("Error:", e);
      } finally {
        this.isLoading = false;
      }
    },

    onFileChange(event, type) {
      const file = event.target.files[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onload = (e) => {
        if (type === "profile") {
          this.profile_path = e.target.result;
        } else if (type === "background") {
          this.background_path = e.target.result;
        }
      };
      reader.readAsDataURL(file);
    },

    resetImage(type) {
      if (type === "profile") {
        this.$refs.profileFile.value = null;
        this.profile_path = null;
      } else if (type === "background") {
        this.$refs.backgroundFile.value = null;
        this.background_path = null;
      }
    },

    async saveUserTimestamp() {
      try {
        const timestampData = {
          from_path: `/rooms/${this.form.id}`,
          from_name: "RoomEditPage",
          user_id: this.user.id,
          old_json: JSON.stringify(this.old_json),
          new_json: JSON.stringify(this.form),
        };
        await axios.post(`/user_timestamps`, timestampData);
      } catch (error) {
        console.log("Timestamp error:", error);
      }
    },
  },
};
</script>
